import {
  Typography,
  Box,
} from '@mui/material';
import { IClientDropdownItem } from '../../../../entity-interfaces/IClientDropdownItem';
import { Nullable } from '@jamesgmarks/utilities';

interface CreatedNotesModeProps {
  selectedClient: Nullable<IClientDropdownItem>;
  createdNotesCount?: number;
}

export const CreatedNotesMode = ({
  selectedClient,
  createdNotesCount = 0,
}: CreatedNotesModeProps) => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        🎉 Success! Your credit notes have been created in unpublished status.
      </Typography>

      <Box sx={{
        mb: 3,
        p: 2,
        bgcolor: 'green.50',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'green.200',
      }}>
        <Typography variant="h6" sx={{ mb: 1, color: 'green.800' }}>
          Credit Notes Created Successfully
        </Typography>
        <Typography variant="body2" sx={{ color: 'green.700' }}>
          <strong>Client:</strong> {selectedClient?.name}
        </Typography>
        <Typography variant="body2" sx={{ color: 'green.700' }}>
          <strong>Credit Notes Created:</strong> {createdNotesCount}
        </Typography>
        <Typography variant="body2" sx={{ color: 'green.700', mt: 2 }}>
          The credit notes have been created in unpublished status. You can now review and publish them
          from the Credit Notes list.
        </Typography>
      </Box>
    </>
  );
};
